import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Document} from '../model/Entities/Document';
import {DocumentType} from '../model/Entities/DocumentType';
import {DocumentCompany} from '../model/Entities/DocumentCompany';
import {DocumentLink} from '../model/Entities/DocumentLink';

@Injectable()
export class DocumentLinkService extends ApiService<DocumentLink> {

    protected apiUrl = 'api/document-link';  // URL to web api

    protected getObjectType(): any {
        return DocumentLink;
    }
}



// WEBPACK FOOTER //
// /app/src/services/document-link.service.ts